import { Reveal } from "@components/ui";

const internshipAreas = [
  {
    title: "Engineering",
    description: "Hands-on experience with gas infrastructure and smart systems.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    ),
  },
  {
    title: "Customer Service",
    description: "Learn frontline support for residential and commercial clients.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    title: "Digital Operations",
    description: "Work with smart metering, portals, and energy platforms.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    title: "Administration",
    description: "Support operations, HR, and compliance workflows.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    title: "Billing & Finance",
    description: "Gain exposure to utility billing, collections, and accounting.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },
];

const InternshipSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[120px] bg-[#f1f1f1] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#1a7a4f]/10 text-[#1a7a4f] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Grow With Us
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              Internship & Training Programs
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[800px]">
              Developing UAE talent and supporting young professionals entering
              the utilities sector
            </p>
          </div>
        </Reveal>

        {/* Internship area cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {internshipAreas.map((area, index) => (
            <Reveal
              key={area.title}
              className={index === internshipAreas.length - 1 ? "sm:col-span-2 lg:col-span-1" : ""}
            >
              <div className="group h-full bg-white rounded-[20px] border border-[rgba(98,99,108,0.15)] p-6 md:p-7 hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:border-[rgba(26,122,79,0.25)] transition-all duration-300">
                {/* Icon */}
                <div className="w-12 h-12 rounded-[14px] bg-[#1a7a4f]/8 flex items-center justify-center text-[#1a7a4f] mb-5 group-hover:bg-[#1a7a4f] group-hover:text-white transition-all duration-300">
                  {area.icon}
                </div>

                <h3 className="text-[20px] md:text-[24px] font-semibold text-[#090d2c] tracking-[-0.04em] mb-2">
                  {area.title}
                </h3>
                <p className="text-[15px] md:text-[18px] text-[#62636c] tracking-[-0.04em] leading-relaxed">
                  {area.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* CTA banner */}
        <Reveal>
          <div className="mt-10 md:mt-14 rounded-[20px] bg-gradient-to-r from-[#1a7a4f] to-[#0d5c3a] p-6 md:p-8 lg:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h3 className="text-[20px] md:text-[24px] lg:text-[28px] font-semibold text-white tracking-[-0.04em]">
                Ready to Start Your Career?
              </h3>
              <p className="text-[15px] md:text-[18px] text-white/75 tracking-[-0.04em] mt-1.5">
                GASIS internships are open to UAE nationals and residents.
              </p>
            </div>
            <a
              href="mailto:careers@gasis.ae?subject=Internship%20Application&body=Dear%20GASIS%20HR%20Team%2C%0A%0AI%20would%20like%20to%20apply%20for%20an%20internship%20opportunity.%0A%0AFull%20Name%3A%20%0APhone%20Number%3A%20%0AArea%20of%20Interest%3A%20%0A%0APlease%20find%20my%20CV%20attached.%0A%0AThank%20you."
              className="shrink-0 inline-flex items-center gap-2 bg-white text-[#1a7a4f] rounded-[40px] px-6 py-3 text-[16px] md:text-[18px] font-semibold hover:bg-white/90 hover:shadow-[0_4px_16px_rgba(0,0,0,0.15)] transition-all duration-300"
            >
              Apply for Internship
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                className="ml-1"
              >
                <path
                  d="M4.167 10h11.666M10.833 5l5 5-5 5"
                  stroke="currentColor"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default InternshipSection;
